<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >场景组审核</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入开发编号或数字员工名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 140px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="需求年份" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.requireYear"
                                    type="year"
                                    placeholder="请选择年份"
                                    style="width: 130px"
                                    value-format="yyyy"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="上岗年份" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.publishYear"
                                    type="year"
                                    placeholder="请选择年份"
                                    style="width: 130px"
                                    value-format="yyyy"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="FP是否维护" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.FPDone"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value=""
                                        label="全部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column
                            align="center"
                            title="审批"
                            width="100"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.status === '2'"
                                    status="success"
                                    icon="fa fa-check"
                                    round
                                    @click="auditRowEvent(row)"
                                    >审批
                                </vxe-button>
                                <vxe-button
                                    v-else
                                    icon="vxe-icon-search"
                                    status="info"
                                    round
                                    @click="viewRowEvent(row)"
                                    >查看
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="状态"
                            width="160"
                            align="center"
                            resizable
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.statusName }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="processName"
                            title="数字员工名称"
                            width="180"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="processDesc"
                            title="工作场景描述"
                            width="200"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="sceneBussValue"
                            title="场景业务价值"
                            width="200"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="FPCount"
                            title="FP功能点数"
                            width="120"
                            show-overflow
                            resizable
                            sortable
                            ><template #default="{ row }">
                                <vxe-button
                                    :style="{
                                        color: '#1890ff',
                                        textDecoration: 'underline',
                                    }"
                                    type="text"
                                    @click="showFPEstimate(row)"
                                    >{{ row.FPCount }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="createDate"
                            title="创建日期"
                            width="120"
                            sortable
                            :formatter="formatTime"
                        ></vxe-column>
                        <vxe-column
                            field="bussName"
                            title="申请人姓名"
                            width="120"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="divison"
                            title="总部"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="dept"
                            title="部门"
                            width="100"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="office"
                            title="科室"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="winMan"
                            title="部门窗口"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="leader"
                            title="科长"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="bussEmail"
                            title="申请人邮箱"
                            width="180"
                            show-overflow
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="selfLevelName"
                            title="优先级"
                            width="120"
                        ></vxe-column>
                        <vxe-column
                            field="planPlatformName"
                            title="计划部署平台"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="planPublishDate"
                            title="计划上线时间"
                            width="160"
                            sortable
                            :formatter="formatTime"
                        ></vxe-column>
                        <vxe-column
                            field="processID"
                            title="开发编号"
                            width="130"
                            sortable
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="requireNo"
                            title="需求编号"
                            width="130"
                            sortable
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- RPA-->
            <vxe-modal
                v-model="formInput.isShow"
                :title="formInput.title"
                width="840"
                height="600"
                @close="closeWinEvent"
                show-zoom
                resize
                remember
                show-footer
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="开发编号"
                            field="processID"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.processID"
                                    readonly
                                    placeholder="审批通过后系统自动生成"
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工名称"
                            field="processName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.processName"
                                    placeholder="请输入数字员工名称"
                                    :disabled="allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="工作场景描述"
                            field="processDesc"
                            span="24"
                            title-width="120px"
                        >
                            <vxe-textarea
                                v-model="formInput.formData.processDesc"
                                placeholder="填写（流程、痛点、解决方案）"
                                maxlength="500"
                                show-word-count
                                :disabled="allInputDisable"
                                readonly
                            ></vxe-textarea>
                        </vxe-form-item>
                        <vxe-form-item
                            title="场景业务价值"
                            field="sceneBussValue"
                            span="24"
                            title-width="120px"
                        >
                            <vxe-textarea
                                v-model="formInput.formData.sceneBussValue"
                                placeholder="填写（体验、收益、效率）"
                                maxlength="500"
                                show-word-count
                                :disabled="allInputDisable"
                                readonly
                            ></vxe-textarea>
                        </vxe-form-item>
                        <vxe-form-item
                            title="申请人(孵化者)"
                            field="bussName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.bussName"
                                    placeholder="请输入姓名"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部"
                            field="divison"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.divison"
                                    placeholder="请输入总部"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="部门"
                            field="dept"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.dept"
                                    placeholder="请输入部门"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="科室"
                            field="office"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.office"
                                    placeholder="请输入科室"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="部门窗口"
                            field="winMan"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.winMan"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="科长"
                            field="leader"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.leader"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button :disabled="true">选择</vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="计划部署平台"
                            field="planPlatform"
                            span="12"
                            title-width="140px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.planPlatform"
                                    :options="formInput.planPlatform"
                                    placeholder="请选择计划部署平台"
                                    :disabled="allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="优先级"
                            field="selfLevel"
                            span="12"
                            title-width="120px"
                            :visible="false"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.selfLevel"
                                    placeholder="请选择优先级自判"
                                    clearable
                                    :disabled="true"
                                    readonly
                                >
                                    <vxe-option
                                        value="1"
                                        label="低"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="高"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开发工具或语言"
                            field="otherPlatform"
                            span="12"
                            title-width="130px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.otherPlatform"
                                    placeholder="请输入开发工具或语言"
                                    :disabled="
                                        formInput.formData.planPlatform !==
                                            'PT006' || allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="计划上线时间"
                            field="planPublishDate"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    transfer
                                    v-model="formInput.formData.planPublishDate"
                                    type="date"
                                    placeholder="请输入计划上线时间"
                                    :disabled="true"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="辅导老师"
                            field="isNeedTutor"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.isNeedTutor"
                                    placeholder="辅导老师"
                                    clearable
                                    transfer
                                    :disabled="allInputDisable"
                                    @change="tutorTypeChange"
                                >
                                    <vxe-option
                                        value="0"
                                        label="无需辅导老师"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="自动分配辅导老师"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="指定辅导老师"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="指定辅导老师"
                            field="tutorUID"
                            span="12"
                            title-width="120px"
                            :visible="formInput.formData.isNeedTutor == '2'"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.tutorUID"
                                    :options="formInput.allTutors"
                                    placeholder="请选择辅导老师"
                                    :disabled="allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="FP智能估算"
                            field="FPCount"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.FPCount"
                                    readonly
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button @click="estimateFP" status="primary"
                                    >估算</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="是否涉及AI"
                            field="isAI"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.isAI"
                                    placeholder="请选择是否涉及AI"
                                    clearable
                                    :disabled="allInputDisable"
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            v-if="isViewFooter"
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="24" v-if="isViewFooter">
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinion"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
                <!-- 底部按钮栏 -->
                <template #footer v-if="isViewFooter">
                    <div style="text-align: center; width: 100%">
                        <vxe-button
                            @click="reject"
                            icon="fa fa-reply"
                            status="danger"
                            >驳回
                        </vxe-button>
                        <vxe-button
                            @click="submit"
                            :loading="submitLoading"
                            icon="fa fa-check"
                            status="success"
                            >通过
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>
            <!--选择辅导老师 -->
            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item title="关键字" :item-render="{}">
                                <template #default>
                                    <vxe-input
                                        v-model="userTablePager.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="uid"
                                title="uid"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="handlePageChangeUser"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
    <FPEstimate ref="fpestimateRef" @updateTotal="handleTotal"></FPEstimate>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";

import { VXETable } from "vxe-table";
import MyAuditLine from "../myPlug/MyAuditLine";
import FPEstimate from "./FPEstimate.vue";
import XEUtils from "xe-utils";

export default {
    name: "SceneAudit",
    components: { MyAuditLine, FPEstimate },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            allStatus: [],
            formData: {
                status: "2", //场景组审核中
                searchKey: "",
                requireYear: "",
                FPDone: "",
                publishYear: "",
            },
        });

        const formInput = reactive({
            title: "场景组审核",
            isShow: false,
            planPlatform: [],
            winMan: "",
            winManUID: "",
            allTutors: [],
            allReqPlatform: [],
            formData: {
                Id: "",
                processID: "",
                processName: "",
                processDesc: "",
                bussName: "",
                divison: "",
                status: "",
                dept: "",
                office: "",
                bussEmail: "",
                selfLevel: "2", //优先级自判 中
                requireNo: "",
                leader: "",
                leaderUID: "",
                winMan: "",
                winManUID: "",
                devDifficulty: "1", //默认低
                planPublishDate: "",
                sceneBussValue: "",
                isNeedTutor: "",
                planPlatform: "",
                tutorName: "",
                tutorUID: "",
                FPCount: 0,
                isAI: "",
            },
            formRules: {
                processID: [{ required: false, message: "开发编号不能为空" }],
                processName: [
                    { required: true, message: "请输入数字员工名称" },
                ],
                processDesc: [
                    { required: true, message: "请输入工作场景描述" },
                ],
                bussName: [{ required: true, message: "请输入姓名" }],
                divison: [{ required: true, message: "请输入总部" }],
                dept: [{ required: true, message: "请输入部门" }],
                office: [{ required: true, message: "请输入科室" }],
                bussEmail: [{ required: true, message: "请输入邮箱" }],
                selfLevel: [{ required: true, message: "请选择优先级" }],
                winMan: [{ required: true, message: "请选择部门窗口人" }],
                leader: [{ required: true, message: "请选择科长" }],
                planPublishDate: [
                    { required: true, message: "请选择计划上线时间" },
                ],
                sceneBussValue: [
                    { required: true, message: "请输入场景业务价值" },
                ],
                isNeedTutor: [
                    { required: true, message: "请选择是否需要辅导老师" },
                ],
                planPlatform: [
                    { required: true, message: "请选择计划部署平台" },
                ],
                tutorUID: [{ required: true, message: "请选择辅导老师" }],
                FPCount: [{ required: true, message: "请输入FP智能估算" }],
                isAI: [{ required: true, message: "请选择是否涉及AI" }],
            },
        });

        const auditOpinion = ref("OK");
        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const fpestimateRef = ref(null);
        const editReqId = ref("");
        const editSource = ref("1"); // 1 详情页编辑 2 表格进入
        return {
            tableData: null,
            userTablePager,
            tablePager,
            toolbar,
            pageHeight,
            formInput,
            dtUser: null,
            userSelectType: 2, //1 多选 2 单选
            iShowSelectUser: ref(false),
            submitLoading: false,
            auditOpinion,
            dtAudit: [],
            isShowAuditList: false,
            tableHeight: 0,
            isViewFooter: true,
            allInputDisable: false,
            fpestimateRef,
            editReqId,
            editSource,
        };
    },
    methods: {
        findData() {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    "3",
                    this.toolbar.formData.status,
                    "",
                    "",
                    this.toolbar.formData.requireYear,
                    this.toolbar.formData.FPDone,
                    this.toolbar.formData.publishYear,
                ], //2 表示场景组
            };
            this.$api.newRequireManageAPI
                .getRequireList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleTotal(total) {
            if (this.editSource === "1") {
                this.formInput.formData.FPCount = total;
            } else {
                const params = {
                    Id: this.editReqId,
                    FPCount: total,
                };
                this.$api.newRequireManageAPI
                    .updateFPCount(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "更新FP功能点数成功",
                            status: "success",
                        });
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        showFPEstimate(row) {
            this.editReqId = row.Id;
            this.editSource = "2";
            this.$refs.fpestimateRef.openModal(row.Id, row.processName, false);
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey, ""],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectUser() {
            this.userTablePager.searchKey = "";
            this.findUserData();
            this.iShowSelectUser = true;
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.formInput.formData.tutorName = record.UserName;
            this.formInput.formData.tutorUID = record.uid;
            this.iShowSelectUser = false;
        },
        handlePageChange() {
            this.findData();
        },
        handlePageChangeUser() {
            this.findUserData();
        },
        formatTime({ cellValue, row, column }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        tutorTypeChange() {
            this.formInput.formRules.tutorUID[0].required =
                this.formInput.formData.isNeedTutor == "2";
        },
        //审核记录
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;

                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
        },

        //审核数据
        auditRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.requireManageAPI
                .getRequireOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data.dataTable[0];
                    this.formInput.formRules.tutorUID[0].required =
                        this.formInput.formData.isNeedTutor === "1";
                    this.formInput.title = "场景组审核";
                    this.auditOpinion = "OK";
                    this.allInputDisable = false;
                    this.isViewFooter = true;
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //查看数据
        viewRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.requireManageAPI
                .getRequireOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data.dataTable[0];
                    this.formInput.title = "查看需求";
                    this.allInputDisable = true;
                    this.isViewFooter = false;
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeWinEvent() {
            this.findData();
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        estimateFP() {
            this.editSource = "1";
            this.$refs.fpestimateRef.openModal(
                this.formInput.formData.Id,
                this.formInput.formData.processName,
                false
            );
        },
        addAuditRecord(bussid, status) {
            //写审核日志
            const params = {
                auditBuId: bussid,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: this.auditOpinion,
                auditNode: "",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getModel(stat) {
            const requires = {
                Id: this.formInput.formData.Id,
                status: stat,
                dept: this.formInput.formData.dept,
                tutorUID: this.formInput.formData.tutorUID,
                tutorName: this.selectedTutorLabel,
                isNeedTutor: this.formInput.formData.isNeedTutor,
                planPlatform: this.formInput.formData.planPlatform,
                bussName: this.$store.state.userName,
                sceneBussValue: this.auditOpinion,
                FPCount: this.formInput.formData.FPCount,
                isAI: this.formInput.formData.isAI,
            };

            return requires;
        },
        //驳回
        async reject() {
            if (this.auditOpinion === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                let params = this.getModel("4"); // 场景组驳回
                this.$api.newRequireManageAPI
                    .auditRequires(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.findData();
                        //审核记录
                        this.addAuditRecord(this.formInput.formData.Id, "2"); //2 驳回

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            if (this.auditOpinion === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }
            const fp = this.formInput.formData.FPCount;

            if (fp == null || fp === "" || Number(fp) <= 0) {
                VXETable.modal.message({
                    content: "FP功能点数不能为空或小于等于0",
                    status: "error",
                });
                return;
            }
            this.submitLoading = true;
            let params = this.getModel("5"); // 审核通过
            this.$api.newRequireManageAPI
                .auditRequires(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "审批成功",
                        status: "success",
                    });
                    this.findData();
                    this.addAuditRecord(this.formInput.formData.Id, "1"); //1 通过
                    this.formInput.isShow = false;
                    this.submitLoading = false;
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    this.submitLoading = false;
                    console.log(error);
                });
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["26"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        if (
                            item.LookupValueCode === "0" ||
                            item.LookupValueCode === "1" ||
                            item.LookupValueCode === "3"
                        ) {
                            continue;
                        }
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindAllReqPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["27"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.allReqPlatform = [];
                    for (const item of res.data.Data) {
                        this.formInput.allReqPlatform.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindTechMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getTechMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allTutors = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allTutors.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.bindPlatform(); //计划部署平台
        this.bindAllStatus(); // 状态
        this.bindTechMember(); // 加载技术组
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserId() {
            return this.$store.state.userID;
        },
        selectedTutorLabel() {
            const selected = this.formInput.allTutors.find(
                (t) => t.value === this.formInput.formData.tutorUID
            );
            return selected ? selected.label : "";
        },
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}

.form-container {
    padding-bottom: 80px; /* 给底部按钮留空间 */
}

.form-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 10px 20px;
    text-align: center;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
}
</style>
<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
